<div class="mesgs">
  <div *ngIf="sessionService.user.permessions == sessionService.permessionTypes.CLIENT" class="msg_history">
    <div *ngFor="let msg of messages">
      <div *ngIf="msg.fromId == sessionService.user.id" class="outgoing_msg">
        <div class="sent_msg">
          <p>{{ msg.message }}</p>
          <span class="time_date">
            {{ msg.createdAt | date: "dd/MM/yy HH:mm" }}</span
          >
        </div>
      </div>

      <div *ngIf="msg.fromId != sessionService.user.id" class="incoming_msg">
        <!-- <div class="incoming_msg_img">
          <img
            src="https://ptetutorials.com/images/user-profile.png"
            alt="sunil"
          />
        </div> -->
        <div class="received_msg">
          <div class="received_withd_msg">
            <p>{{ msg.message }}</p>
            <span class="time_date">
              {{ msg.createdAt | date: "dd/MM/yy HH:mm" }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="sessionService.user.permessions != sessionService.permessionTypes.CLIENT" class="msg_history">
    <div *ngFor="let msg of messages">
      <div *ngIf="msg.fromUser?.permessions != sessionService.permessionTypes.CLIENT" class="outgoing_msg">
        <div class="sent_msg">
          <p>{{ msg.message }}</p>
          <span class="time_date">
            {{ msg.createdAt | date: "dd/MM/yy HH:mm" }}</span
          >
        </div>
      </div>

      <div *ngIf="msg.fromUser?.permessions == sessionService.permessionTypes.CLIENT" class="incoming_msg">
        <!-- <div class="incoming_msg_img">
          <img
            src="https://ptetutorials.com/images/user-profile.png"
            alt="sunil"
          />
        </div> -->
        <div class="received_msg">
          <div class="received_withd_msg">
            <p>{{ msg.message }}</p>
            <span class="time_date">
              {{ msg.createdAt | date: "dd/MM/yy HH:mm" }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="type_msg">
    <div class="input_msg_write">
      <input
        name="msg"
        type="text"
        class="write_msg"
        placeholder="Type a message"
      />
      <button (click)="sendRequest()" class="msg_send_btn" type="button">
        <ion-icon name="send"></ion-icon>
      </button>
    </div>
  </div>
</div>
